import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanDeactivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { LiveComponent } from 'app/modules/event/live/live.component';
import { CookieService } from 'ngx-cookie-service';
import { CreditHoursService } from '../../shared/services/credit-hours.service';

@Injectable({ providedIn: 'root' })
export class CMEGuard implements CanActivate, CanDeactivate<LiveComponent> {
  constructor(
    private cookieService: CookieService,
    private cme: CreditHoursService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    const queryToken = route.queryParamMap.get('token');

    if (queryToken) {
      localStorage.setItem('token', queryToken);
    }

    const token =
      queryToken ||
      this.cookieService.get('token') ||
      localStorage.getItem('token') ||
      '';

    if (!token) {
      return this.redirectToLogin(route);
    }

    return true;
  }

  canDeactivate(component: LiveComponent) {
    this.check_out();
    return true;
  }

  private redirectToLogin(route: ActivatedRouteSnapshot): UrlTree {
    const hall = route.paramMap.get('hall') || route.queryParamMap.get('hall') || undefined;

    return this.router.createUrlTree(['/login'], {
      queryParams: { hall },
    });
  }

  private clearToken(): void {
    localStorage.removeItem('token');
    this.cookieService.delete('token');
  }

  check_out() {
    this.cme.check_out('Yes');
  }
}
